<template :key="$route.fullPath">
  <div v-if="loading" class="flex justify-center my-24 p-4 text-sm">
    <div class="text-yellow-700">
      <svg class="inline mr-3 w-6 h-6 text-blue-700 animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
      </svg>
    </div>
    <span class="ml-1 text-gray-500 text-xl">
            Cargando facturas
          </span>
  </div>

  <div v-show="this.billing < 1" class="text-center mt-10 mb-8">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mx-auto h-12 w-12 text-gray-400">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
    </svg>
    <label class="px-6 py-3 text-sm leading-4 font-bold text-gray-500 uppercase tracking-wider">
      No hay ninguna factura
    </label>
    <p class="hidden mt-1 text-sm text-gray-500">
      {{ $t('video.text_upload_file') }}
    </p>
  </div>

  <div v-show="!loading" class="mx-6 lg:mx-24 bg-white shadow sm:rounded-md sm:overflow-hidden my-6">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="overflow-hidden border-t border-gray-200">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Fecha
                  </th>
                  <th scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Campo 2
                  </th>
                  <th scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Campo 3
                  </th>
                  <th scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Campo 4
                  </th>
                  <!--
                      `relative` is added here due to a weird bug in Safari that causes `sr-only` headings to introduce overflow on the body on mobile.
                    -->
                  <th scope="col"
                      class="relative px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <span class="">{{ $t('settings.view_receipt') }}</span>
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="subscription in authUserStore.user.academy.saas_subscriptions" v-bind:key="subscription.id">
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {{ $moment(subscription.ends_at).format('DD-MM-YYYY HH:m') }}
                  Fecha de facturación
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-bold">
                  {{ subscription.title }}<br>
                  <span v-if="subscription.status == 'trialing'" class="font-normal">
                      {{
                      $t('settings.trial_ends_on')
                    }} {{ $moment(subscription.trial_ends_at).format('DD-MM-YYYY HH:m') }}
                    </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ subscription.status }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ subscription.total }} €
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <a href="#" class="hidden text-bpblue hover:text-bpbluedeep">
                    {{ $t('settings.view_receipt') }}
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mb-10">
    <pagination-billing-component :pagination="pagination"></pagination-billing-component>
  </div>


</template>

<script>
import BillingService from "@/services/saas/BillingService";
import {useAuthUserStore} from "@/stores/auth";
import PaginationBillingComponent from "@/views/MyAccount/Billing/PaginationBillingComponent";

export default {
  name: "BillingComponent",
  components: {
    PaginationBillingComponent,
  },

  data:() => {
    return {
      loading: false,
      invoices: null,
      pagination: {
        current_page: null,
        from: null,
        last_page: null,
        per_page: null,
        to: null,
        total: null
      },
      billing: null,
    }
  },
  setup () {
    const authUserStore = useAuthUserStore();

    return {
      authUserStore,
    }
  },

  created() {
    this.getBilling()
  },
  methods: {

    getBilling() {
      this.loading = true
      let academy_uuid = this.authUserStore.user.academy.uuid;
      console.log("El academy uuid es: ", academy_uuid)

      BillingService.index(academy_uuid)
          .then((response) => {
            console.log("Obtenidas las facturas", response)
            this.invoices = response
          })
          .catch((error) => {
            console.log("Error al obtener las facturas", error)
          })
          .finally(() => {
            this.loading = false
          })

    }

  }

}
</script>

<style scoped>

</style>